import { render } from "./Surcharge.vue?vue&type=template&id=1cfd4c98&scoped=true"
import script from "./Surcharge.vue?vue&type=script&lang=js"
export * from "./Surcharge.vue?vue&type=script&lang=js"

import "./Surcharge.vue?vue&type=style&index=0&id=1cfd4c98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cfd4c98"]])

export default __exports__